import React from 'react';
import PropTypes from 'prop-types';
import $ from 'jquery';
import 'slick-carousel';
import 'slick-carousel/slick/slick.css';
import Steps from "./register_member_component/Steps";
import Step1 from "./register_member_component/Step1";
import Step2 from "./register_member_component/Step2";
import Step3 from "./register_member_component/Step3";
import 'core-js/stable'
import 'regenerator-runtime/runtime'
import 'react-app-polyfill/ie11'


class CreateNewMember extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      currentStep: 1,
    };
    this.sliderRef = React.createRef();
    this.slickGoTo = this.slickGoTo.bind(this);
  }

  /**
   * slickのページ移動を行う
   * page=[0,1,2...] (page=slickのページ番号)
   * step=[1,2,3...] (step=画面上部の進行状況番号)
   * @param page <code>page >= 0</code>
   */
  slickGoTo(page) {
    $(this.sliderRef.current).slick('slickGoTo', page);
    this.setState({ currentStep: page + 1 /*pageは0からスタートするため1を足す*/ })
  }

  render() {
    return (
      <React.Fragment>
        <Steps currentStep={this.state.currentStep} stepSize={4} />
        <div className="slider" ref={this.sliderRef}>
          <Step1
            defaultMember={this.props.member}
            validate_step1_url={this.props.validate_step1_url}
            csrf_token={this.props.csrf_token}
            slickGoTo={this.slickGoTo}>
          </Step1>
          <Step2
            defaultMember={this.props.member}
            validate_step2_url={this.props.validate_step2_url}
            associations_list={this.props.associations_list}
            csrf_token={this.props.csrf_token}
            slickGoTo={this.slickGoTo}>
          </Step2>
          <Step3
            defaultMember={this.props.member}
            validate_step3_url={this.props.validate_step3_url}
            move_to_step4_url={this.props.move_to_step4_url}
            csrf_token={this.props.csrf_token}
            slickGoTo={this.slickGoTo}>
          </Step3>
        </div>
      </React.Fragment>
    )
  }

  componentDidMount() {
    // render後にslickを適応する
    $(this.sliderRef.current).slick({
      dots: false,
      pauseOnHover: false,
      pauseOnDotsHover: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      swipe: false,
      accessibility: false,
      arrows: false,
    });

    $(document).ready(function() {
      if (navigator.userAgent.match(/(iPod|iPhone|iPad)/)) {
        // 現在フォーカスが当たっているinputにreadonlyを設定
        $('input, select').on('focus', function() {
          $('input').not(this).attr("readonly", "readonly");
          $('select').not(this).attr("disabled", "disabled");
        });

        // フォーカスが外れるときにreadonlyを外す
        $('input, select').on('blur', function() {
          $('input').removeAttr("readonly");
          $('select').removeAttr("disabled");
        });

        // selectのtabindexに-1を設定
        $('select').attr('tabindex', '-1');
      }
    });

    // 初期表示のフォーカス
    $('#tabindex_step1').focus();

    // step1: 1, 2
    // step1: 3, 4, 5, 6, 7
    // step3: 8, 9
    $(document).on('keydown', function (event) {
      const tabKeyCode = 9;
      const enterKeyCode = 13;

      // 現在のtabindex
      let current = document.activeElement.tabIndex

      // Enter押下時 ボタンクリックイベント発火
      if (event.keyCode === enterKeyCode) {
        switch(current) {
          case 1:
          case 2:
            document.getElementById('form_index_2').click();
            break;
          case 5: // 3, 4 はセレクトボックスなので何もしない
          case 6:
          case 7:
            document.getElementById('form_index_7').click();
            break;
          case 8:
          case 9:
            document.getElementById('form_index_9').click();
            break;
        }

      // Tab押下時 フォーカス移動制御
      } else if (event.keyCode === tabKeyCode) {
        event.preventDefault();

        if (event.shiftKey) {
          // Shift + Tab 逆方向に制御
          switch(current) {
            case 10001: // STEP1
            case 1:
              $('#form_index_2').focus();
              break;
            case 2:
              $('#form_index_1').focus();
              break;
            case 10002: // STEP2
            case 3:
              $('#form_index_7').focus();
              break;
            case 4:
              $('#form_index_3').focus();
              break;
            case 5:
              $('#form_index_4').focus();
              break;
            case 6:
              $('#form_index_5').focus();
              break;
            case 7:
              $('#form_index_6').focus();
              break;
            case 10003: // STEP3 表示後、最初にtab押下で１つ目のフォームに移動
            case 8:
              $('#form_index_9').focus();
              break;
            case 9:
              $('#form_index_8').focus();
              break;
            
          }

        } else {
          // Tab
          switch(current) {
            case 10001: // STEP1 表示後、最初にtab押下で１つ目のフォームに移動
              $('#form_index_1').focus();
              break;
            case 1:
              $('#form_index_2').focus();
              break;
            case 2:
              $('#form_index_1').focus();
              break;
            case 10002: // STEP2 表示後、最初にtab押下で１つ目のフォームに移動
              $('#form_index_3').focus();
              break;
            case 3:
              $('#form_index_4').focus();
              break;
            case 4:
              $('#form_index_5').focus();
              break;
            case 5:
              $('#form_index_6').focus();
              break;
            case 6:
              $('#form_index_7').focus();
              break;
            case 7:
              $('#form_index_3').focus();
              break;
            case 10003: // STEP3 表示後、最初にtab押下で１つ目のフォームに移動
              $('#form_index_8').focus();
              break;
            case 8:
              $('#form_index_9').focus();
              break;
            case 9:
              $('#form_index_8').focus();
              break;
          }
        }
      }
    });
  }

  // STEP遷移時（スライド後）に毎回呼ばれる処理
  componentDidUpdate(prevProps, prevState) {
    // 最新のSTEPを取得
    let step = prevState.currentStep + 1;

    // 各STEPを横断するフォーカス移動を行うとデザインが崩れるため、一旦slickの外にフォーカスを逃がす
    switch(step) {
      case 2:
        $('#tabindex_step2').focus();
        break;
      case 3:
        $('#tabindex_step3').focus();
        break;
    }
  }

  /**
   * 不必要になったslickを外す
   */
  componentWillUnmount() {
    $(this.sliderRef.current).slick('unslick');
  }
  
}

CreateNewMember.propTypes = {
  member: PropTypes.object,
  associations_list: PropTypes.array,
  validate_step1_url: PropTypes.string,
  validate_step2_url: PropTypes.string,
  validate_step3_url: PropTypes.string,
  move_to_step4_url: PropTypes.string,
  csrf_token: PropTypes.string,
};

export default CreateNewMember;